import React, { useRef, useEffect } from 'react';
import * as d3 from 'd3';
import "../styles.css";

export default function D3View2 ({ data }) {
  const ref = useRef();
  useEffect(() => {




//     const margin = { top: 20, right: 20, bottom: 30, left: 40 };
//     const width = 360 - margin.left - margin.right;
//     const height = 300 - margin.top - margin.bottom;
//     const x = d3.scaleBand()
//       .range([0, width])
//       .padding(0.1);
//     const y = d3.scaleLinear()
//       .range([height, 0]);
//     const svg = d3.select(ref.current)
//       .append('svg')
//       .attr('width', width + margin.left + margin.right)
//       .attr('height', height + margin.top + margin.bottom)
//       .append('g')
//       .attr('transform', `translate(${margin.left},${margin.top})`);
//     x.domain(data.map(d => d.label));
//     y.domain([0, d3.max(data, d => d.value)]);
//     svg.selectAll('.bar')
//       .data(data)
//       .enter().append('rect')
//       .attr('class', 'bar')
//       .attr('x', d => x(d.label))
//       .attr('y', d => y(d.value))
//       .attr('width', x.bandwidth())
//       .attr('height', d => height - y(d.value));
//     svg.append('g')
//       .attr('transform', `translate(0,${height})`)
//       .call(d3.axisBottom(x));
//     svg.append('g')
//       .call(d3.axisLeft(y));

  }, [data]);

  return (
    <div ref={ref}></div>
  );
};






